import React, { useState, useRef, useEffect, useContext } from 'react';
import { Stage, Layer, Transformer, Image, Circle, Arrow, Rect, Text } from 'react-konva';
import Konva from 'konva'
import Context from "../../../utils/Context"
import useImage from 'use-image'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSave } from "@fortawesome/free-solid-svg-icons"
import logo from '../../../assets/images/logo.png'
import api from '../../../api/api';
import OccupancyGridVisualizer from "../Map/OccupancyGridVisualizer"
import { ImageUtils } from 'three';

export function Map(props) {
    const context = useContext(Context)

    const {
        canvasRef,
        openModal,
        updateCanvas,
        robotPos
    } = props

    const [mapImage, setMapImage] = useState('')

    const [mapImageVersion, setMapImageVersion] = useState(0)
    const [stageVisibility, setStageVisibility] = useState(false)
    const [labelVisibility, setLabelVisibility] = useState(false)
    const [pointClickState, setPointClickState] = useState(false)
    const [pointType, setPointType] = useState([true, false])
    const [lineType, setLineType] = useState([true, false])
    const [isDragging, setIsDragging] = useState(false)
    const [pointName, setPointName] = useState('')
    const [lastDist, setLastDist] = useState(0)
    const [clickState, setClickState] = useState(2)
    const [lineState, setLineState] = useState(0)
    const [isNew, setIsNew] = useState(false)
    const [menuPosX, setMenuPosX] = useState(0)
    const [menuPosY, setMenuPosY] = useState(0)
    const [repeatCounter, setRepeatCounter] = useState(0)
    //const [linesInfo, setLinesInfo] = useState([])
    const [linePoint, setLinePoint] = useState({ id: 0, x: 0, y: 0 })
    const [selectedRect, setSelectedRect] = useState({})
    //const [dragCoords, setDragCoords] = useState({ x: 0, y: 0 })
    const [pointLabel, setPointLabel] = useState({ x: 0, y: 0, name: '' })
    const [selectedShapes, setSelectedShapes] = useState([])
    const [selectionBox, setSelectionBox] = useState({ visible: false, x: 0, y: 0, width: 0, height: 0 })
    const [draggable, setDraggable] = useState(false)
    const [preModalValues, setPreModalValues] = useState([])

    const [linesInfo, setLinesInfo] = useState({})
    const [dragCoords, setDragCoords] = useState({})

    const layerRef = useRef()
    const imageRef = useRef()
    const shapeRef = useRef({})
    const timerRef = useRef()
    const loadingRef = useRef()
    const stageRef = useRef()
    const trRef = useRef(null)
    const selectionRectRef = useRef(null)
    const selecting = useRef(false)
    const stageProps = useRef({ scale: 1, x: 0, y: 0 })
    const multiDragHelper = useRef([])

    let [image, status] = useImage(`${mapImage}`, 'anonymous')

    const deepClone = (obj) => {
        return JSON.parse(JSON.stringify(obj))
    }

    useEffect(() => {
        let updatedLines = []

        context.konvaPoints && context.konvaPoints.length > 0 && context.konvaPoints.forEach((point, i) => {
            if (i === 0) {
                updatedLines = context.konvaEdges.map((edge) => {
                    //console.log(edge.pointIds, point.name)
                    if (edge.pointIds[0] === point.name) {
                        return {
                            ...edge,
                            points: [point.x, point.y, edge.points[2], edge.points[3]]
                        }
                    } else if (edge.pointIds[1] === point.name) {
                        return {
                            ...edge,
                            points: [edge.points[0], edge.points[1], point.x, point.y]
                        }
                    } else return edge
                })
            } else {
                updatedLines = updatedLines.map((edge) => {
                    //console.log(edge.pointIds, point.name)
                    if (edge.pointIds[0] === point.name) {
                        return {
                            ...edge,
                            points: [point.x, point.y, edge.points[2], edge.points[3]]
                        }
                    } else if (edge.pointIds[1] === point.name) {
                        return {
                            ...edge,
                            points: [edge.points[0], edge.points[1], point.x, point.y]
                        }
                    } else return edge
                })
            }

            //console.log(i, point.name, updatedLines)
        })
        //console.log(updatedLines)

        context.actions.setKonvaEdges(updatedLines)
    }, [context.konvaPoints])

    useEffect(() => {
        if (stageRef.current) {
            stageRef.current.scale({ x: stageProps.current.scale, y: stageProps.current.scale })
            stageRef.current.position({ x: stageProps.current.x, y: stageProps.current.y })
            stageRef.current.batchDraw()
        }
    }, [stageProps.current])

    useEffect(() => {
        console.log(context.mappingStatus)
        if (context.mappingStatus) {
            setMapImage(`http://${context.selectedRobot.ip}/temp_map.png`)
            timerRef.current = setInterval(() => {
                setMapImage('')
                setTimeout(() => {
                    console.log('refetching...')
                    setMapImage(`http://${context.selectedRobot.ip}/temp_map.png?t=${Date.now()}`)
                }, [50])
            }, [5000])
        } else {
            const currentMap = context.maps.find(m => m.name === context.selected?.map?.name)
            clearInterval(timerRef.current)
            if (currentMap) loadImage(currentMap)
        }

        return () => {
            if (timerRef.current) clearInterval(timerRef.current)
        }
    }, [context.mappingStatus, context.mappingCurrent])

    useEffect(() => {
        console.log(context.endOfMission, context.mappingStatus)

        if (context.selected.tool?._id === "location" && context.robotPosition) {
            setIsNew(true)
            setPointType([true, false, false])
            document.getElementById('point-modal').classList.add('is-active')
            setPreModalValues([deepClone(context.konvaPoints), deepClone(context.konvaEdges), deepClone(context.konvaAreas)])
            document.getElementById('pointName').classList.add('is-flex')

            const currentMap = context.maps.find(m => m.name === context.selected.map?.name)

            setMenuPosX(((context.robotPosition.position.x - currentMap.origin.x)).toFixed(6))
            setMenuPosY((-(context.robotPosition.position.y - currentMap.origin.y) + context.mapDimensions.height * currentMap.resolution).toFixed(6))

            const here = {
                radius: 5,
                fill: 'blue',
                x: (context.robotPosition.position.x - currentMap.origin.x) / currentMap.resolution,
                y: -(context.robotPosition.position.y - currentMap.origin.y) / currentMap.resolution + context.mapDimensions.height,
                draggable: 'true',
                name: 'point' + repeatCounter
            }
            //console.log('new point!', isDragging)
            setRepeatCounter(repeatCounter + 1)
            context.actions.setKonvaPoints([...context.konvaPoints, here])

            context.actions.setChanges([...context.changes, { old: [context.konvaPoints, context.konvaEdges, context.konvaAreas], new: [[...context.konvaPoints, here], context.konvaEdges, context.konvaAreas] }])
            context.actions.setUndone([])
            context.actions.setSelected({ ...context.selected, tool: { _id: 'points', name: 'Navigation' } })
        }
    }, [context.selected.tool?._id])

    //ON INIT: HITONDRAGENABLED, OR ELSE MAP BREAKS :)
    useEffect(() => {
        console.log(context.endOfMission, context.lastMission)

        context.actions.setSelector(false)
        let currentMap

        Konva.hitOnDragEnabled = true
        if (context.settings.fmsConnection) {
            currentMap = context.maps.find(m => m.name == context.selected.map?.name && m.robotId === context.robotInfo._id)
        } else {
            currentMap = context.maps[0]
        }

        console.log(context.maps, currentMap)

        if (currentMap?._id) {
            if ((context.lastMission === 'select-map' && context.endOfMission) || context.lastMission !== 'select-map') {
                console.log(currentMap)
                loadImage(currentMap)
                console.log(currentMap.objects)
                if (context.settings.fmsConnection) context.actions.setMapObjects(currentMap.objects)
                clearInterval(loadingRef.current)
            } else {
                loadingRef.current = setInterval(() => {
                    if (document.getElementById('loading').innerHTML !== 'Loading map...') {
                        document.getElementById('loading').innerHTML += '.'
                    } else {
                        document.getElementById('loading').innerHTML = 'Loading map'
                    }
                }, [500])
                setMapImage('')
            }
        } else {
            console.warn('No map selected')
            clearInterval(loadingRef.current)
        }

        return () => {
            if (loadingRef.current) clearInterval(loadingRef.current)
        }
    }, [context.selected.map, context.endOfMission])

    useEffect(() => {
        if (isNew) {
            let id = 0
            let newShape
            layerRef.current.children.forEach((item) => {
                if (item._id > id) {
                    id = item._id
                    newShape = item
                }
            })
            console.log(newShape)
            shapeRef.current = newShape
        }
    }, [isNew])

    //LOADS THE MAP
    const loadImage = async (map) => {
        let img = imageRef.current
        //console.log('http://' + context.settings.fmsIp + '/fms' + map.link)
        //setMapImage('http://' + context.settings.fmsIp + '/fms' + map.link)

        updateCanvas(document.getElementById('canvas-id'))

        console.log(map, map.objects)

        const mapUrl = 'http://' + context.selectedRobot.ip + map.link + '?=' + Date.now();
        console.log('Setting Map Image:', mapUrl); // Debug to ensure URL is correct

        setMapImage(mapUrl)
        setMapImageVersion((prev) => prev + 1)
        setStageVisibility(true)

        console.log(img, map, image)
    }

    useEffect(() => {
        if (image) {
            console.log('MAP FEED', context.mapFeedFull)
            let img = imageRef.current
            stageProps.current = { ...stageProps.current, x: (stageRef.current.attrs.width - image.width) / 2, y: (stageRef.current.attrs.height - image.height) / 2 }

            let map
            if (context.settings.fmsConnection) map = context.maps.find(m => m.name === context.selected.map?.name && m.robotId === context.robotInfo._id)
            else map = context.maps[0]
            context.actions.setMapDimensions({ width: img.attrs.image.width, height: img.attrs.image.height, resolution: map ? map.resolution : null })
            //img.position({ x: context.mapFeed?.position[0], y: context.mapFeed?.position[1] })
            //img.scale({ x: context.mapFeed?.scale[0], y: context.mapFeed?.scale[1] })

            console.log(map?.objects)

            if (map?.objects) {
                let allPoints = []
                let allLines = []
                let allAreas = []
                if (map.objects.points) {
                    let importedPoints = []
                    map.objects.points.map((point) => {
                        importedPoints.push({
                            draggable: 'true',
                            fill: 'blue',
                            name: point.name[0],
                            radius: 5,
                            //x: (point.point.x - map.origin.x) / map.resolution,
                            x: (point.point.x - map.origin.x) / map.resolution,
                            //y: (point.point.y - map.origin.y) / map.resolution,
                            y: -(point.point.y - map.origin.y) / map.resolution + img.attrs.image.height
                        })
                    })

                    allPoints = importedPoints
                    //setPoints(importedPoints)
                }

                if (map.objects.edges) {
                    let importedLines = []
                    map.objects.edges.map((line) => {
                        const startPoint = allPoints.find((point) => point.name === line.from)
                        const endPoint = allPoints.find((point) => point.name === line.to)
                        console.log(startPoint, endPoint)
                        let color = 'blue'
                        let pointer = false

                        if (line.avoid) color = 'purple'

                        if (!line.reversable) pointer = true

                        if (startPoint && endPoint) {
                            importedLines.push({
                                points: [startPoint.x, startPoint.y, endPoint.x, endPoint.y],
                                stroke: color,
                                hitStrokeWidth: 15,
                                fill: color,
                                opacity: 0.5,
                                name: startPoint.name + ' a ' + endPoint.name,
                                pointerAtEnding: pointer,
                                pointIds: [startPoint.name, endPoint.name]
                            })
                        }
                    })
                    console.log(importedLines)

                    allLines = importedLines
                }

                if (map.objects.no_go) {
                    let nogoPoints = []
                    let nogoLines = []
                    let previousPoints = []
                    let closedPolygon = false

                    map.objects.no_go.map((area) => {
                        area.polygon.map((point) => {
                            if (previousPoints.length === 0 || !previousPoints.includes(point.counter)) {
                                nogoPoints.push({
                                    draggable: 'true',
                                    fill: 'red',
                                    name: point.counter,
                                    radius: 4,
                                    //x: (point.point.x - map.origin.x) / map.resolution,
                                    x: (point.point.x - map.origin.x) / map.resolution,
                                    //y: (point.point.y - map.origin.y) / map.resolution,
                                    y: -(point.point.y - map.origin.y) / map.resolution + img.attrs.image.height
                                })

                                previousPoints.push(point.counter)
                            } else {
                                closedPolygon = true
                            }
                        })

                        previousPoints = []

                        for (let i = 0; i < nogoPoints.length; i++) {
                            let point = nogoPoints[i]
                            let nextPoint
                            if (i === nogoPoints.length - 1) {
                                break
                            } else {
                                nextPoint = nogoPoints[i + 1]
                            }

                            nogoLines.push({
                                points: [point.x, point.y, nextPoint.x, nextPoint.y],
                                stroke: 'red',
                                hitStrokeWidth: 15,
                                fill: 'red',
                                opacity: 0.5,
                                name: point.name + ' a ' + nextPoint.name,
                                pointerAtEnding: false,
                                pointIds: [point.name, nextPoint.name]
                            })
                        }

                        if (closedPolygon) {
                            closedPolygon = false

                            nogoLines.push({
                                points: [nogoLines[nogoLines.length - 1].points[2], nogoLines[nogoLines.length - 1].points[3], nogoLines[0].points[0], nogoLines[0].points[1]],
                                stroke: 'red',
                                hitStrokeWidth: 15,
                                fill: 'red',
                                opacity: 0.5,
                                name: nogoLines[nogoLines.length - 1].pointIds[1] + ' a ' + nogoLines[0].pointIds[0],
                                pointerAtEnding: false,
                                pointIds: [nogoLines[nogoLines.length - 1].pointIds[1], nogoLines[0].pointIds[0]]
                            })
                        }

                        allPoints = allPoints.concat(nogoPoints)
                        nogoPoints = []
                    })

                    console.log(nogoPoints)
                    console.log(nogoLines)

                    allLines = allLines.concat(nogoLines)
                }

                if (map.objects.areas) {
                    let slowAreas = []

                    map.objects.areas.map((area) => {
                        let fillColor, strokeColor = ''
                        console.log(area)

                        if (!area.beep) {
                            fillColor = '#FFB47F'
                            strokeColor = 'orange'
                        } else {
                            fillColor = '#FF7FE8'
                            strokeColor = 'hotpink'
                        }
                        slowAreas.push({
                            name: area.name,
                            fill: fillColor,
                            stroke: strokeColor,
                            strokeWidth: 1,
                            opacity: 0.6,
                            x: (area.polygon[0].point.x - map.origin.x) / map.resolution,
                            y: -(area.polygon[0].point.y - map.origin.y) / map.resolution + img.attrs.image.height,
                            draggable: 'true',
                            height: -((-(area.polygon[0].point.y - map.origin.y) / map.resolution + img.attrs.image.height) - (-(area.polygon[3].point.y - map.origin.y) / map.resolution + img.attrs.image.height)),
                            width: ((area.polygon[1].point.x - map.origin.x) / map.resolution) - ((area.polygon[0].point.x - map.origin.x) / map.resolution),
                            rotation: Math.atan2(area.polygon[1].point.y - area.polygon[0].point.y, area.polygon[1].point.x - area.polygon[0].point.x) * (180 / Math.PI),
                            scaleX: 1,
                            scaleY: 1,
                            velocity: area.velocity
                        })
                    })

                    console.log(slowAreas)

                    allAreas = allAreas.concat(slowAreas)
                }

                console.log(allPoints, allLines, allAreas)

                setRepeatCounter(allPoints.length + allAreas.length)
                context.actions.setKonvaPoints(allPoints)
                context.actions.setKonvaEdges(allLines)
                context.actions.setKonvaAreas(allAreas)
            } else {
                context.actions.setKonvaPoints([])
                context.actions.setKonvaEdges([])
                context.actions.setKonvaAreas([])
            }
        }
    }, [image])

    //HANDLES EVERYTHING THAT HAPPENS ONCE YOU START DRAGGING THE MAP OR ANY SHAPE
    const handleOnDragStart = (e) => {
        //e.evt.preventDefault()
        multiDragHelper.current = []

        unpopShapes()
        context.actions.setSelector(false)
        if (e.target.getClassName() === 'Rect') {
            setSelectedRect({ ...e.target.attrs })
        } else if (e.target.getClassName() === 'Transformer') {
            setSelectedRect({})
        }
        //console.log(document.getElementById('shapeChooser').style.display)

        let center = {
            x: e.target.attrs.x,
            y: e.target.attrs.y
        }

        console.log('HEYHEYHEYHEYHEYHEYHEYHEY', e.target, center)

        setIsDragging(true)
        shapeRef.current = e.target

        let layer = layerRef.current

        const imageHitbox = layer.children[0]

        imageHitbox.cache()
        imageHitbox.drawHitFromCache()
        //e.target.hitStrokeWidth(20)

        let pointCoords = dragCoords

        if (e.target.attrs.name) {
            pointCoords[e.target.attrs.name] = center
            setDragCoords(pointCoords)
        }

        //console.log(e.target)

        console.log('--dragging--', e.target.getClassName(), e.target.attrs?.name, dragCoords, pointCoords)
    }

    //HANDLES EVERYTHING THAT HAPPENS AFTER DRAGGING THE MAP OR ANY SHAPE
    const handleOnDragEnd = (e) => {
        //e.evt.preventDefault()

        //console.log(e.target.getStage())
        const center = {
            x: dragCoords[e.target.attrs.name]?.x !== e.target.attrs?.x ? e.target.attrs.x : null,
            y: dragCoords[e.target.attrs.name]?.y !== e.target.attrs?.y ? e.target.attrs.y : null
        }

        if (!center.x && !center.y && e.target.getClassName() === 'Circle') return

        let layer = layerRef.current, stage = stageRef.current

        if (e.target.getClassName() === 'Circle') {
            if (selectedShapes.length === 0)
                popShape(e)
            //else selectedShapes.forEach((shape) => popShape({ target: shape }))
        } else {
            unpopShapes()
        }

        setIsDragging(false)
        //setLineState(0)

        console.log('event type?', e.evt?.type)
        console.log('--dragged--', e.target.getClassName(), e.target.attrs?.name, center)

        const oldScale = stage.scaleX()
        const pos = {
            x: oldScale * center.x + stage.x(),
            y: oldScale * center.y + stage.y()
        }

        const imageHitbox = layer.children[0]

        imageHitbox.cache()
        imageHitbox.drawHitFromCache()

        //console.log(dragCoords)
        //console.log(xPos, yPos)
        //console.log(imageHitbox.intersects({x: pos.x, y: pos.y}))

        if (e.target.getClassName() !== 'Stage' && e.target.getClassName() !== 'Transformer') {
            if ((!imageHitbox.intersects({ x: pos.x, y: pos.y }) && e.target.attrs.fill !== 'red' && e.target.attrs.fill !== '#FFB47F' && e.target.getClassName() === 'Circle' && selectedShapes < 2) || (!context.endOfMission)) {
                //console.log(pos)

                e.target.x(dragCoords[e.target.attrs.name].x)
                e.target.y(dragCoords[e.target.attrs.name].y)

                unpopShapes()

                const invalidDrag = context.konvaPoints.map((p, i) => {
                    //console.log(e.target.index)

                    if ((i + 4) === (e.target.index - context.konvaEdges.length - context.konvaAreas.length)) { //ADD +1 TO i EVERYTIME YOU ADD A SHAPE ABOVE CIRCLES
                        console.log(i, p, dragCoords[e.target.attrs.name])
                        setPointLabel({ x: dragCoords[e.target.attrs.name].x, y: dragCoords[e.target.attrs.name].y, name: e.target.attrs.name })

                        return {
                            ...p,
                            x: dragCoords[e.target.attrs.name].x,
                            y: dragCoords[e.target.attrs.name].y
                        }
                    } else return p
                })

                //console.log(invalidDrag)

                context.actions.setKonvaPoints(invalidDrag)
            } else {
                switch (e.target.getClassName()) {
                    case 'Circle':
                        if (selectedShapes.length < 2) {
                            const newCoords = context.konvaPoints.map((point, i) => {
                                //console.log(e.target.getLayer())

                                if ((i + 4) === (e.target.index - context.konvaEdges.length - context.konvaAreas.length)) { //ADD +1 TO i EVERYTIME YOU ADD A SHAPE ABOVE CIRCLES
                                    //console.log(xPos, yPos)
                                    setPointLabel({ x: center.x, y: center.y, name: e.target.attrs.name })

                                    return {
                                        ...point,
                                        x: center.x,
                                        y: center.y,
                                    }
                                } else return point
                            })

                            console.log('new coords?', newCoords, context.konvaPoints)
                            context.actions.setKonvaPoints(newCoords)

                            context.actions.setChanges([...context.changes, { old: [context.konvaPoints, context.konvaEdges, context.konvaAreas], new: [newCoords, context.konvaEdges, context.konvaAreas] }])
                            context.actions.setUndone([])
                        } else {
                            console.log(multiDragHelper.current)
                            const newCoords = context.konvaPoints.map((point, i) => {
                                //console.log(e.target.getLayer())

                                if ((i + 4) === (e.target.index - context.konvaEdges.length - context.konvaAreas.length)) { //ADD +1 TO i EVERYTIME YOU ADD A SHAPE ABOVE CIRCLES
                                    //console.log(xPos, yPos)

                                    return {
                                        ...point,
                                        x: center.x,
                                        y: center.y,
                                    }
                                } else return null
                            })

                            multiDragHelper.current = multiDragHelper.current.concat(newCoords)

                            let deleteNulls = multiDragHelper.current.filter(function (el) {
                                return el != null
                            })

                            console.log('new coords?', multiDragHelper.current, context.konvaPoints)

                            let concatted = context.konvaPoints.concat(deleteNulls)
                            const seen = new Set()
                            context.actions.setKonvaPoints(concatted.slice().reverse().filter(point => {
                                if (seen.has(point.name)) {
                                    return false
                                }
                                seen.add(point.name)
                                return true
                            }))

                            context.actions.setChanges([...context.changes, { old: [context.konvaPoints, context.konvaEdges, context.konvaAreas], new: [deleteNulls, context.konvaEdges, context.konvaAreas] }])
                            context.actions.setUndone([])
                        }
                        break

                    case 'Rect':
                        const newAreaCoords = context.konvaAreas.map((area) => {
                            //console.log(e.target.getLayer())

                            if (area.name === e.target.attrs.name) {
                                //console.log(center)

                                return {
                                    ...area,
                                    x: center.x,
                                    y: center.y,
                                }
                            } else return area
                        })

                        context.actions.setKonvaAreas(newAreaCoords)

                        context.actions.setChanges([...context.changes, { old: [context.konvaPoints, context.konvaEdges, context.konvaAreas], new: [context.konvaPoints, context.konvaEdges, newAreaCoords] }])
                        context.actions.setUndone([])
                        break

                    case 'Transformer':
                        console.log(e.target)
                        break

                    default:
                        break
                }
            }
        }
        selecting.current = false
        setSelectionBox((prev) => ({ ...prev, visible: false }))
        setSelectedShapes([])
        trRef.current.nodes([])

        //setDragCoords(center)
        setDragCoords({})

        //console.log('dropped', dragCoords.x, dragCoords.y)
        //console.log('dropped', e.target.x(), e.target.y())
        layer.batchDraw()

        console.log('points:', context.konvaPoints)
        console.log('edges:', context.konvaEdges)
        console.log('zones:', context.konvaAreas)
        console.log('dropped!', pos.x, pos.y)
    }

    //CHECKS IF THE CLICK WAS ON THE MAP FOR DROPDOWN TO SHOW
    const mapDetection = (e) => {
        //e.evt.preventDefault()

        e.target.cache()
        e.target.drawHitFromCache()
        e.target.hitStrokeWidth(20)

        setClickState(e.target._id)

        console.log('clicked map!', e.target._id);
    }

    //SCROLL ZOOM HANDLER
    const scrollZoom = (e) => {
        e.evt.preventDefault()
        const stage = e.target.getStage()

        var scaleBy = 1.1
        var oldScale = stage.scaleX()
        var pointer = stage.getPointerPosition()
        var mousePointTo = {
            x: (pointer.x - stage.x()) / oldScale,
            y: (pointer.y - stage.y()) / oldScale
        }

        let direction = e.evt.deltaY > 0 ? 1 : -1

        if (e.evt.ctrlKey) {
            direction = -direction
        }

        var newScale = direction < 0 ? oldScale * scaleBy : oldScale / scaleBy

        var newPos = {
            x: pointer.x - mousePointTo.x * newScale,
            y: pointer.y - mousePointTo.y * newScale
        }

        if (newScale < 0.2) {
            newScale = 0.2
            newPos.x = stageProps.current.x
            newPos.y = stageProps.current.y
        }
        if (newScale > 5) {
            newScale = 5
            newPos.x = stageProps.current.x
            newPos.y = stageProps.current.y
        }

        stageProps.current = {
            scale: newScale,
            x: newPos.x,
            y: newPos.y
        }

        stage.scale({ x: newScale, y: newScale })
        stage.position(newPos)
        stage.batchDraw()
    }

    //TOUCH ZOOM HANDLER
    const pinchZoom = (e) => {
        //e.evt.preventDefault()
        const stage = e.target.getStage()

        var touch1 = e.evt.touches[0]
        var touch2 = e.evt.touches[1]

        if (touch1 && touch2) {
            setIsDragging(true)
            stage.draggable(false)
            var oldScale = stage.scaleX()

            var pointer1 = {
                x: touch1.clientX - 3,
                y: touch1.clientY - 50
            }
            var pointer2 = {
                x: touch2.clientX - 3,
                y: touch2.clientY - 50
            }

            var center = {
                x: (pointer1.x + pointer2.x) / 2,
                y: (pointer1.y + pointer2.y) / 2
            }

            const dist = Math.sqrt(Math.pow(pointer2.x - pointer1.x, 2) + Math.pow(pointer2.y - pointer1.y, 2))

            if (lastDist !== 0) {
                var newScale = oldScale * (dist / lastDist)
            } else var newScale = oldScale

            var zoomPoint = {
                x: (center.x - stage.x()) / oldScale,
                y: (center.y - stage.y()) / oldScale
            }

            setLastDist(dist)

            var newPos = {
                x: center.x - zoomPoint.x * newScale,
                y: center.y - zoomPoint.y * newScale
            }

            if (newScale < 0.2) {
                newScale = 0.2
                newPos.x = stageProps.current.x
                newPos.y = stageProps.current.y
            }

            if (newScale > 5) {
                newScale = 5
                newPos.x = stageProps.current.x
                newPos.y = stageProps.current.y
            }
            //console.log(Konva.hitOnDragEnabled)

            stageProps.current = {
                scale: newScale,
                x: newPos.x,
                y: newPos.y
            }

            stage.scale({ x: newScale, y: newScale })
            stage.position(newPos)
            stage.batchDraw()
            //console.log('double touch!', stageProps)
        }
    }

    //TOUCH ZOOM RESETTER
    const pinchReset = (e) => {
        if (e.evt.touches.length === 0) {
            setIsDragging(false)
            e.target.getStage().draggable(true)
            setLastDist(0)
        }
    }

    // SETS LINE CREATION
    const lineHandler = (e) => {
        //unpopModal()
        if (lineState === 0) { //início de uma linha
            setLinePoint({ id: e.target._id, x: e.target.attrs.x, y: e.target.attrs.y, color: e.target.attrs.fill, name: e.target.attrs.name })
            setLineState(1)
            console.log(shapeRef.current)
        } else {
            if ((linePoint.id === e.target._id) || (linePoint.color !== e.target.attrs.fill)) {
                setLineState(0)
                console.log('line canceled')
            } else {       //fim de uma linha, evitando linha a ser criada com dois cliques no mesmo ponto OU em pontos com cor diferente
                const newLine = {
                    points: [linePoint.x, linePoint.y, e.target.attrs.x, e.target.attrs.y],
                    stroke: linePoint.color,
                    hitStrokeWidth: 15,
                    fill: linePoint.color,
                    opacity: 0.5,
                    name: linePoint.name + ' a ' + e.target.attrs.name,
                    pointerAtEnding: false,
                    pointIds: [linePoint.name, e.target.attrs.name]
                }

                let isOverlap = false

                context.konvaEdges.map((l) => {
                    console.log(newLine.pointIds, l.pointIds)
                    if ((newLine.pointIds[0] == l.pointIds[0] && newLine.pointIds[1] == l.pointIds[1]) || (newLine.pointIds[0] == l.pointIds[1] && newLine.pointIds[1] == l.pointIds[0])) {
                        console.log('overlap!')
                        isOverlap = true
                    }

                    setLineState(0)
                    return l
                })

                console.log(isOverlap)

                if (isDragging === false && isOverlap === false) {
                    console.log('new line!')
                    context.actions.setKonvaEdges([...context.konvaEdges, newLine])

                    context.actions.setChanges([...context.changes, { old: [context.konvaPoints, context.konvaEdges, context.konvaAreas], new: [context.konvaPoints, [...context.konvaEdges, newLine], context.konvaAreas] }])
                    context.actions.setUndone([])
                    //console.log(lines)
                }

                setLineState(0)
            }
        }
    }

    //POINT CREATOR
    const createPoint = (e) => {
        const oldScale = e.target.getStage().scaleX()
        const mousePointTo = {
            x: e.target.getStage().getPointerPosition().x / oldScale - e.target.getStage().x() / oldScale,
            y: e.target.getStage().getPointerPosition().y / oldScale - e.target.getStage().y() / oldScale
        }

        console.log(e.target._id, clickState, pointClickState, isDragging)

        if (((e.target._id === clickState || clickState === 0) && !pointClickState && !context.selector && !isDragging && context.endOfMission)) {
            setMenuPosX((mousePointTo.x * context.mapDimensions.resolution).toFixed(4))
            setMenuPosY(((mousePointTo.y - 0.125) * context.mapDimensions.resolution).toFixed(4)) //o y estava a ser calculado com 0.125 a mais

            setSelectedRect({})
            setIsNew(true)
            setPointType([true, false])
            document.getElementById('point-modal').classList.add('is-active')
            setPreModalValues([deepClone(context.konvaPoints), deepClone(context.konvaEdges), deepClone(context.konvaAreas)])
            document.getElementById('pointName').classList.add('is-flex')

            const newPoint = {
                radius: 5,
                fill: 'blue',
                x: mousePointTo.x,
                y: mousePointTo.y - 0.125,
                draggable: 'true',
                name: 'point' + repeatCounter
            }
            //console.log('new point!', isDragging)
            setRepeatCounter(repeatCounter + 1)
            setPointName('point' + repeatCounter)
            context.actions.setKonvaPoints([...context.konvaPoints, newPoint])

            context.actions.setChanges([...context.changes, { old: [context.konvaPoints, context.konvaEdges, context.konvaAreas], new: [[...context.konvaPoints, newPoint], context.konvaEdges, context.konvaAreas] }])
            context.actions.setUndone([])
        } else if (e.target.getClassName() === 'Arrow' && e.target.attrs.stroke !== 'red' && context.selected.tool?._id === 'points') {
            setMenuPosX((mousePointTo.x * context.mapDimensions.resolution).toFixed(4))
            setMenuPosY(((mousePointTo.y - 0.125) * context.mapDimensions.resolution).toFixed(4)) //o y estava a ser calculado com 0.125 a mais

            setSelectedRect({})
            setIsNew(true)
            setPointType([true, false])
            document.getElementById('point-modal').classList.add('is-active')
            setPreModalValues([deepClone(context.konvaPoints), deepClone(context.konvaEdges), deepClone(context.konvaAreas)])
            document.getElementById('pointName').classList.add('is-flex')

            const newPoint = {
                radius: 5,
                fill: 'blue',
                x: mousePointTo.x,
                y: mousePointTo.y - 0.125,
                draggable: 'true',
                name: 'point' + repeatCounter
            }
            //console.log('new point!', isDragging)
            setRepeatCounter(repeatCounter + 1)
            setPointName('point' + repeatCounter)
            context.actions.setKonvaPoints([...context.konvaPoints, newPoint])

            const newLine1 = {
                points: [e.target.attrs.points[0], e.target.attrs.points[1], mousePointTo.x, mousePointTo.y - 0.125],
                stroke: e.target.attrs.stroke,
                hitStrokeWidth: 15,
                fill: e.target.attrs.fill,
                opacity: 0.5,
                name: e.target.attrs.pointIds[0] + ' a ' + 'point' + repeatCounter,
                pointerAtBeginning: e.target.attrs.pointerAtBeginning,
                pointerAtEnding: e.target.attrs.pointerAtEnding,
                pointIds: [e.target.attrs.pointIds[0], 'point' + repeatCounter]
            }

            const newLine2 = {
                points: [mousePointTo.x, mousePointTo.y - 0.125, e.target.attrs.points[2], e.target.attrs.points[3]],
                stroke: e.target.attrs.stroke,
                hitStrokeWidth: 15,
                fill: e.target.attrs.fill,
                opacity: 0.5,
                name: 'point' + repeatCounter + ' a ' + e.target.attrs.pointIds[1],
                pointerAtBeginning: e.target.attrs.pointerAtBeginning,
                pointerAtEnding: e.target.attrs.pointerAtEnding,
                pointIds: ['point' + repeatCounter, e.target.attrs.pointIds[1]]
            }

            const deletedLine = context.konvaEdges.map((line) => {
                if (line.name === e.target.attrs.name) {
                    return null
                } else return line
            })

            let filterDeleted = deletedLine.filter((point) => {
                return point != null
            })

            context.actions.setKonvaEdges(filterDeleted.concat([newLine1, newLine2]))

            context.actions.setChanges([...context.changes, { old: [context.konvaPoints, context.konvaEdges, context.konvaAreas], new: [[...context.konvaPoints, newPoint], filterDeleted.concat([newLine1, newLine2]), context.konvaAreas] }])
            context.actions.setUndone([])
        } else {
            if (e.target.getClassName() !== 'Circle' && e.target.getClassName() !== 'Rect') {
                unpopShapes()
            }
        }

    }

    //POINT EDITOR
    const editPoint = (e) => {
        //e.evt.preventDefault()

        if (!isDragging && context.endOfMission) {
            let pointCreator = document.getElementById('point-creator')
            const originalShape = e.target
            setPointName(originalShape.attrs.name)
            console.log(document.getElementsByName('pointType'))

            switch (originalShape.attrs.fill) {
                case 'blue':
                    setPointType([true, false])
                    document.getElementById('pointName').classList.add('is-flex')
                    break;

                case 'red':
                    setPointType([false, true])
                    document.getElementById('pointName').classList.remove('is-flex')
                    break;

                /*case 'orange':
                    setPointType([false, false, true])
                    document.getElementById('pointName').style.display = 'none'
                    break;*/

                default:
                    break;
            }

            shapeRef.current = originalShape
            console.log('editing?', context.mapDimensions.resolution, originalShape.attrs.x, originalShape.attrs.y)
            setIsNew(false)
            document.getElementById('point-modal').classList.add('is-active')
            setPreModalValues([deepClone(context.konvaPoints), deepClone(context.konvaEdges), deepClone(context.konvaAreas)])

            setMenuPosX((originalShape.attrs.x * context.mapDimensions.resolution).toFixed(6))
            setMenuPosY((originalShape.attrs.y * context.mapDimensions.resolution).toFixed(6))
        }
    }

    const didMount = (e) => {
        let mounted

        if (e.target.getClassName() === 'Rect') {
            mounted = e.target
            shapeRef.current = e.target
        } else {
            mounted = e.target.getStage().findOne('.' + selectedRect.name)
        }

        console.log(context.selector, isDragging)

        if (!context.selector) {
            unpopShapes()
            context.actions.setSelector(true)
            console.log(mounted)

            setSelectedRect({ ...mounted.attrs })
        } else if (!isDragging) {
            editArea(e)
        }
    }


    //AREA CREATOR
    const createArea = (e) => {
        const oldScale = e.target.getStage().scaleX()
        const mousePointTo = {
            x: e.target.getStage().getPointerPosition().x / oldScale - e.target.getStage().x() / oldScale,
            y: e.target.getStage().getPointerPosition().y / oldScale - e.target.getStage().y() / oldScale
        }

        if ((e.target._id === clickState || clickState === 0) && !pointClickState && !context.selector && !isDragging && context.endOfMission) {
            document.getElementById('beep').checked = false
            document.getElementById('maxV').value = null
            document.getElementById('area-modal').classList.add('is-active')
            setPreModalValues([deepClone(context.konvaPoints), deepClone(context.konvaEdges), deepClone(context.konvaAreas)])

            const newArea = {
                name: 'area' + repeatCounter,
                fill: '#FFB47F',
                stroke: 'orange',
                strokeWidth: 1,
                opacity: 0.6,
                x: mousePointTo.x - 100 / 2,
                y: mousePointTo.y - 50 / 2,
                height: 50,
                width: 100,
                rotation: 0,
                draggable: 'true',
                scaleX: 1,
                scaleY: 1,
                velocity: 0
            }
            //console.log('new area!', isDragging)
            setSelectedRect({ ...selectedRect, name: 'area' + repeatCounter })
            setIsNew(true)
            setRepeatCounter(repeatCounter + 1)
            context.actions.setKonvaAreas([...context.konvaAreas, newArea])

            context.actions.setChanges([...context.changes, { old: [context.konvaPoints, context.konvaEdges, context.konvaAreas], new: [context.konvaPoints, context.konvaEdges, [...context.konvaAreas, newArea]] }])
            context.actions.setUndone([])
        } else {
            if (e.target.getClassName() !== 'Circle' && e.target.getClassName() !== 'Rect') {
                unpopShapes()
            }
        }
    }


    //AREA EDITOR
    const editArea = (e) => {
        //e.evt.preventDefault()

        if (!isDragging && context.endOfMission) {
            console.log('editing!')
            document.getElementById('area-modal').classList.add('is-active')
            setPreModalValues([deepClone(context.konvaPoints), deepClone(context.konvaEdges), deepClone(context.konvaAreas)])
            const rectangle = layerRef.current.getStage().findOne('.' + selectedRect.name)
            setSelectedRect({ ...rectangle.attrs })
            setIsNew(false)

            if (rectangle.attrs.stroke === 'hotpink') {
                document.getElementById('beep').checked = true
            } else document.getElementById('beep').checked = false

            console.log(document.getElementById('maxV').value, rectangle.attrs.velocity)
            document.getElementById('maxV').value = rectangle.attrs.velocity
        }
    }

    //DELETES LAST CREATED SHAPE
    const undoButton = () => {
        if (context.changes.length > 0) {
            context.actions.setKonvaPoints(context.changes[context.changes.length - 1].old[0])
            context.actions.setKonvaEdges(context.changes[context.changes.length - 1].old[1])
            context.actions.setKonvaAreas(context.changes[context.changes.length - 1].old[2])

            console.log(context.changes)
            let newChanges = context.changes
            context.actions.setUndone([...context.undone, newChanges.pop()])

            context.actions.setChanges(newChanges)
        }

        document.getElementById('point-modal').classList.remove('is-active')
        document.getElementById('line-modal').classList.remove('is-active')
        document.getElementById('area-modal').classList.remove('is-active')

        setIsNew(false)
        console.log('undoing!')
        unpopShapes()
    }

    //DELETES CURRENT POINT
    const deletePoint = () => {
        unpopModal()

        console.log(shapeRef.current.attrs, context.konvaPoints)
        let deletedPoints = context.konvaPoints.map((point) => {
            if (shapeRef.current.attrs.name === point.name) {
                return null
            } else return point
        })

        let filterDeletedP = deletedPoints.filter((point) => {
            return point != null
        })

        let deletedLines = context.konvaEdges.map((line) => {
            if ((shapeRef.current.attrs.x === line.points[0] && shapeRef.current.attrs.y === line.points[1]) || (shapeRef.current.attrs.x === line.points[2] && shapeRef.current.attrs.y === line.points[3])) {
                return null
            } else return line
        })

        let filterDeletedL = deletedLines.filter((line) => {
            return line != null
        })

        context.actions.setKonvaPoints(filterDeletedP)
        context.actions.setKonvaEdges(filterDeletedL)

        context.actions.setChanges([...context.changes, { old: [context.konvaPoints, context.konvaEdges, context.konvaAreas], new: [filterDeletedP, filterDeletedL, context.konvaAreas] }])
        context.actions.setUndone([])
    }

    const deleteArea = () => {
        unpopModal()

        let deletedAreas = context.konvaAreas.map((area) => {
            if (selectedRect.name === area.name) {
                return null
            } else return area
        })

        let filterDeleted = deletedAreas.filter((area) => {
            return area != null
        })

        context.actions.setKonvaAreas(filterDeleted)

        context.actions.setChanges([...context.changes, { old: [context.konvaPoints, context.konvaEdges, context.konvaAreas], new: [context.konvaPoints, context.konvaEdges, filterDeleted] }])
        context.actions.setUndone([])
    }

    const deleteLine = () => {
        unpopModal()

        let deletedLines = context.konvaEdges.map((line) => {
            if (shapeRef.current.attrs.name === line.name) {
                return null
            } else return line
        })

        let filterDeleted = deletedLines.filter((line) => {
            return line != null
        })

        context.actions.setKonvaEdges(filterDeleted)

        context.actions.setChanges([...context.changes, { old: [context.konvaPoints, context.konvaEdges, context.konvaAreas], new: [context.konvaPoints, filterDeleted, context.konvaAreas] }])
        context.actions.setUndone([])
    }

    //CHECKS IF A NEW POINT IS BEING CREATED OR IF ONE IS BEING CURRENTLY EDITED FOR DELETING PURPOSES
    const newCheck = () => {
        //console.log(isNew)
        if (isNew) {
            undoButton()
        } else {
            unpopModal()
        }
    }

    //NAME EDITOR FOR POINTS THAT CHECKS IF THE NAME ALREADY EXISTS
    const nameSaver = (e) => {
        //console.log(e.target.value, shapeRef.current)

        let isCopy = false
        let copyName = e.target.value
        let namer

        context.konvaPoints.forEach((p) => {
            if (copyName === p.name) {
                isCopy = true
                copyName = copyName + 1

                console.log(p, copyName)
            }
        })
        if (!isNew) {
            namer = context.konvaPoints.map((p, i) => {
                if (shapeRef.current.attrs.x === p.x && shapeRef.current.attrs.y === p.y) {
                    if (isCopy) {
                        console.log('repeat!')
                        isCopy = false
                        setPointName(copyName)
                        return {
                            ...p,
                            name: copyName
                        }
                    } else {
                        console.log('unique!')
                        setPointName(e.target.value)
                        return {
                            ...p,
                            name: e.target.value
                        }
                    }
                } else return p
            })
        } else {
            namer = context.konvaPoints.map((p, i) => {
                if (i === context.konvaPoints.length - 1) {
                    if (isCopy) {
                        console.log('repeat!')
                        isCopy = false
                        setPointName(copyName)
                        return {
                            ...p,
                            name: copyName
                        }
                    } else {
                        console.log('unique!')
                        setPointName(e.target.value)
                        return {
                            ...p,
                            name: e.target.value
                        }
                    }
                } else return p
            })
        }

        let edgeNamer = context.konvaEdges.map((l) => {
            for (let i = 0; i < 2; i++) {
                console.log(l.pointIds, pointName)
                if (l.pointIds[i] === pointName) {
                    if (i === 0) {
                        return {
                            ...l,
                            name: e.target.value + ' a ' + l.pointIds[1],
                            pointIds: [e.target.value, l.pointIds[1]]
                        }
                    } else {
                        return {
                            ...l,
                            name: l.pointIds[0] + ' a ' + e.target.value,
                            pointIds: [l.pointIds[0], e.target.value]
                        }
                    }
                }
            }

            return l
        })

        context.actions.setKonvaPoints(namer)
        context.actions.setKonvaEdges(edgeNamer)

        console.log('new point!', isDragging)
    }

    //NAME EDITOR FOR AREAS THAT CHECKS IF THE NAME ALREADY EXISTS
    const areaNameSaver = (e) => {
        //console.log(e.target.value, shapeRef.current)

        let isCopy = false
        let copyName = e.target.value
        let namer

        context.konvaAreas.forEach((a) => {
            if (copyName === a.name) {
                isCopy = true
                copyName = copyName + 1

                console.log(a, copyName)
            }
        })
        if (!isNew) {
            namer = context.konvaAreas.map((a, i) => {
                if (shapeRef.current.attrs.x === a.x && shapeRef.current.attrs.y === a.y) {
                    if (isCopy) {
                        console.log('repeat!')
                        isCopy = false
                        setSelectedRect({ ...selectedRect, name: copyName })
                        return {
                            ...a,
                            name: copyName
                        }
                    } else {
                        console.log('unique!')
                        setSelectedRect({ ...selectedRect, name: e.target.value })
                        return {
                            ...a,
                            name: e.target.value
                        }
                    }
                } else return a
            })
        } else {
            namer = context.konvaAreas.map((a, i) => {
                if (i === context.konvaAreas.length - 1) {
                    if (isCopy) {
                        console.log('repeat!')
                        isCopy = false
                        setSelectedRect({ ...selectedRect, name: copyName })
                        return {
                            ...a,
                            name: copyName
                        }
                    } else {
                        console.log('unique!')
                        setSelectedRect({ ...selectedRect, name: e.target.value })
                        return {
                            ...a,
                            name: e.target.value
                        }
                    }
                } else return a
            })
        }

        context.actions.setKonvaAreas(namer)

        console.log('new area!', isDragging)
    }

    const updateAreas = () => {
        let counter = 0, newAreas = [...context.konvaAreas]
        layerRef.current.children.forEach((child) => {
            if (child.getClassName() === 'Rect' && child.attrs.name) {
                newAreas[counter].x = child.attrs.x
                newAreas[counter].y = child.attrs.y
                newAreas[counter].scaleX = child.attrs.scaleX
                newAreas[counter].scaleY = child.attrs.scaleY
                newAreas[counter].rotation = child.attrs.rotation
                counter += 1
            }
        })

        context.actions.setKonvaAreas([...newAreas])

        let oldAreas = context.konvaAreas.map((a) => {
            if (a.name === selectedRect.name) {
                setSelectedRect({ ...a })

                return {
                    ...a,
                    x: selectedRect.x,
                    y: selectedRect.y,
                    scaleX: selectedRect.scaleX,
                    scaleY: selectedRect.scaleY,
                    rotation: selectedRect.rotation
                }
            } else return a
        })

        context.changes.push({ old: [deepClone(context.konvaPoints), deepClone(context.konvaEdges), deepClone(oldAreas)], new: [deepClone(context.konvaPoints), deepClone(context.konvaEdges), deepClone(newAreas)] })

        context.actions.setChanges([...context.changes])
        context.actions.setUndone([])
    }

    const velocityChange = (e) => {
        const areaVelocity = context.konvaAreas.map((a) => {
            if (!isNew) {
                if (a.name === selectedRect.name) {
                    return {
                        ...a,
                        velocity: parseFloat(document.getElementById('maxV').value),
                    }
                } else return a
            } else {
                if (a.name === shapeRef.current.attrs.name) {
                    return {
                        ...a,
                        velocity: parseFloat(document.getElementById('maxV').value),
                    }
                } else return a
            }
        })

        console.log(areaVelocity, document.getElementById('maxV').value)
        context.actions.setKonvaAreas(areaVelocity)
    }

    //MANUAL COORDINATES FOR POINTS HANDLER
    const manualCoords = (e) => {
        var xValue = Number(document.getElementById('xPos').value) / context.mapDimensions.resolution
        var yValue = Number(document.getElementById('yPos').value) / context.mapDimensions.resolution

        console.log('changed coords', xValue, yValue, context.mapDimensions.resolution)

        console.log(layerRef.current.children[0].getWidth(), e.target.value)

        let displayValueX, displayValueY = ''

        console.log(e.target.value.search(/[.]/))

        //if (imageHitbox.intersects({ x: pos.x, y: pos.y })) {
        if (xValue <= layerRef.current.children[0].getWidth() && yValue <= layerRef.current.children[0].getHeight() && xValue >= 0 && yValue >= 0) {
            /*if (e.target.value.charAt(e.target.value.length - 1) === '.' && e.target.id === 'xPos') {
                displayValueX = xValue * context.mapDimensions.resolution + '.'
                displayValueY = yValue * context.mapDimensions.resolution
            } else if (e.target.value.charAt(e.target.value.length - 1) === '.' && e.target.id === 'yPos') {
                displayValueX = xValue * context.mapDimensions.resolution
                displayValueY = yValue * context.mapDimensions.resolution + '.'
            } else if (e.target.value.charAt(e.target.value.length - 1) === '0' && e.target.value.search(/[.]/) !== -1 && e.target.id === 'xPos') {
                if (e.target.value.charAt(e.target.value.length - 2) === '.' || (e.target.value.charAt(e.target.value.length - 2) === '0' && e.target.value.charAt(e.target.value.length - 3) === '.')) {
                    displayValueX = xValue * context.mapDimensions.resolution + '.0'
                    displayValueY = yValue * context.mapDimensions.resolution
                } else {
                    displayValueX = xValue * context.mapDimensions.resolution + '0'
                    displayValueY = yValue * context.mapDimensions.resolution
                }
            } else if (e.target.value.charAt(e.target.value.length - 1) === '0' && e.target.value.search(/[.]/) !== -1 && e.target.id === 'yPos') {
                if (e.target.value.charAt(e.target.value.length - 2) === '.' || (e.target.value.charAt(e.target.value.length - 2) === '0' && e.target.value.charAt(e.target.value.length - 3) === '.')) {
                    displayValueX = xValue * context.mapDimensions.resolution
                    displayValueY = yValue * context.mapDimensions.resolution + '.0'
                } else {
                    displayValueX = xValue * context.mapDimensions.resolution
                    displayValueY = yValue * context.mapDimensions.resolution + '0'
                }
            } else {
                if (e.target.id === 'xPos') {
                    displayValueX = Number(e.target.value)
                    displayValueY = Number(document.getElementById('yPos').value)
                } else {
                    displayValueX = Number(document.getElementById('xPos').value)
                    displayValueY = Number(e.target.value)
                }
                
            }*/

            if (e.target.id === 'xPos') {
                displayValueX = e.target.value
                displayValueY = document.getElementById('yPos').value
            } else {
                displayValueX = document.getElementById('xPos').value
                displayValueY = e.target.value
            }

            console.log(displayValueX, displayValueY)
            setMenuPosX(displayValueX)
            setMenuPosY(displayValueY)

            console.log('in bounds', shapeRef.current, isNew)
            let newCoords

            if (!isNew) {
                newCoords = context.konvaPoints.map((p, i) => {
                    if (shapeRef.current.attrs.name === p.name) {
                        return {
                            ...p,
                            x: xValue,
                            y: yValue
                        }
                    } else return p
                })
            } else {
                newCoords = context.konvaPoints.map((p, i) => {
                    if (i === context.konvaPoints.length - 1) {
                        return {
                            ...p,
                            x: xValue,
                            y: yValue
                        }
                    } else return p
                })
            }

            context.actions.setKonvaPoints(newCoords)
        }
    }

    //POINT TYPE HANDLER
    const pointProhibition = (e) => {
        let pointCreator = document.getElementById('point-creator')
        let redTurner, blueTurner, greenTurner = null
        console.log(shapeRef.current, e)
        let toBeChanged

        if (!isNew) {
            toBeChanged = shapeRef.current
        } else {
            toBeChanged = layerRef.current.children[layerRef.current.children.length - 2]
        }

        switch (e.target.value) {
            case 'nav':
                blueTurner = context.konvaPoints.map((p, i) => {
                    if (toBeChanged.attrs.name === p.name) {
                        return {
                            ...p,
                            fill: 'blue',
                            radius: 5
                        }
                    } else return p
                })

                context.actions.setKonvaPoints(blueTurner)
                setPointType([true, false, false])
                document.getElementById('pointName').classList.add('is-flex')
                break;

            case 'nogo':
                redTurner = context.konvaPoints.map((p, i) => {
                    if (toBeChanged.attrs.name === p.name) {
                        return {
                            ...p,
                            fill: 'red',
                            radius: 4
                        }
                    } else return p
                })

                context.actions.setKonvaPoints(redTurner)
                setPointType([false, true, false])
                document.getElementById('pointName').classList.remove('is-flex')
                break;

            /*case 'slow':
                greenTurner = context.konvaPoints.map((p, i) => {
                    if (toBeChanged.attrs.name === p.name) {
                        return {
                            ...p,
                            fill: 'orange',
                            radius: 4
                        }
                    } else return p
                })

                context.actions.setKonvaPoints(greenTurner)
                setPointType([false, false, true])
                document.getElementById('pointName').classList.remove('is-flex')
                break;*/

            default:
                break;
        }
    }

    //LINE AVOIDANCE HANDLER
    const onChangeAvoid = () => {
        let lineEditor = document.getElementById('line-editor')

        //console.log(lineEditor.objAv.checked)

        const lineAvoid = context.konvaEdges.map((l) => {
            if (l.name === shapeRef.current.attrs.name) {
                if (lineEditor.objAv.checked) {
                    return {
                        ...l,
                        stroke: 'purple',
                        fill: 'purple'
                    }
                } else return {
                    ...l,
                    stroke: 'blue',
                    fill: 'blue'
                }
            } else return l
        })

        context.actions.setKonvaEdges(lineAvoid)
    }

    //AREA BEEP HANDLER
    const onChangeBeep = () => {
        let areaCreator = document.getElementById('area-creator')
        console.log(shapeRef.current)

        const areaBeep = context.konvaAreas.map((a) => {
            if (!isNew) {
                if (a.name === selectedRect.name) {
                    if (!document.getElementById('beep').checked) {
                        return {
                            ...a,
                            stroke: 'orange',
                            fill: '#FFB47F'
                        }
                    } else return {
                        ...a,
                        stroke: 'hotpink',
                        fill: '#FF7FE8'
                    }
                } else return a
            } else {
                console.log(a, shapeRef.current)
                if (a.name === shapeRef.current.attrs.name) {
                    if (!document.getElementById('beep').checked) {
                        return {
                            ...a,
                            stroke: 'orange',
                            fill: '#FFB47F'
                        }
                    } else return {
                        ...a,
                        stroke: 'hotpink',
                        fill: '#FF7FE8'
                    }
                } else return a
            }
        })

        context.actions.setKonvaAreas(areaBeep)
    }

    //LINE DIRECTION HANDLER
    const lineUpdate = (e) => {
        let lineEditor = document.getElementById('line-editor')
        //console.log(lineEditor.direction.value)

        const lineDir = context.konvaEdges.map((l) => {
            if (l.name === shapeRef.current.attrs.name) {
                switch (e.target.value) {
                    case 'two':
                        setLineType([true, false, false])

                        return {
                            ...l,
                            pointerAtBeginning: false,
                            pointerAtEnding: false
                        }

                    case 'str':
                        setLineType([false, true, false])

                        return {
                            ...l,
                            pointerAtBeginning: false,
                            pointerAtEnding: true
                        }

                    case 'inv':
                        setLineType([false, false, true])

                        return {
                            ...l,
                            pointerAtBeginning: true,
                            pointerAtEnding: false
                        }

                    default:
                        return l
                }
            } else return l
        })

        context.actions.setKonvaEdges(lineDir)
    }

    //LINE EDITING MENU
    const lineMenu = (e) => {
        if (context.endOfMission) {
            let lineEditor = document.getElementById('line-modal')

            //console.log(e.target.attrs.fill, lineEditor.style)

            //shapeEditor.style.top = 85.875 + e.target.getStage().getPointerPosition().y + 4 + 'px'
            //shapeEditor.style.left = e.target.getStage().getPointerPosition().x + 4 + 'px'

            if ((e.target.attrs.stroke === 'blue' || e.target.attrs.stroke === 'purple') && !isDragging) {
                //console.log('WHERE IS THE POP UP')
                if (e.target.attrs.pointerAtEnding) {
                    setLineType([false, true, false])
                } else if (e.target.attrs.pointerAtBeginning) {
                    //console.log('reverse!')
                    setLineType([false, false, true])
                } else setLineType([true, false, false])

                if (e.target.attrs.fill === 'purple') {
                    document.getElementById('objAv').checked = true
                } else document.getElementById('objAv').checked = false
                lineEditor.classList.add('is-active')
                setPreModalValues([deepClone(context.konvaPoints), deepClone(context.konvaEdges), deepClone(context.konvaAreas)])
                //console.log(lineEditor)
                shapeRef.current = e.target
            }
        }
    }

    const pointClick = (e) => {
        console.log(pointClickState, shapeRef.current, e.target)
        if (!pointClickState) {
            popShape(e)
            if (context.endOfMission) lineHandler(e)
            context.actions.setSelector(false)
        } else {
            if (shapeRef.current === e.target && context.endOfMission) {
                editPoint(e)
            } else {
                unpopShapes()
                popShape(e)
                if (context.endOfMission) {
                    lineHandler(e)
                }
            }
        }
    }

    const areaClick = (e) => {
        console.log(context.selector, shapeRef.current, e.target)
        if (context.endOfMission) {
            if (!context.selector) {
                didMount(e)
            } else {
                if (shapeRef.current === e.target) {
                    editArea(e)
                } else {
                    didMount(e)
                }
            }
        }
    }

    //INCREASES POINT SIZE AND ADDS LABEL WITH NAME ON CLICK
    const popShape = (e) => {
        if (selectedShapes.length === 0) shapeRef.current = e.target
        setPointClickState(true)
        if (e.target.getClassName() === 'Circle') {
            e.target.scaleX(1.5)
            e.target.scaleY(1.5)
        }
        //console.log(e.target, isDragging)
        if (e.target.getClassName() === 'Arrow') {
            setPointLabel({ x: (e.target.attrs.points[0] + e.target.attrs.points[2]) / 2, y: (e.target.attrs.points[1] + e.target.attrs.points[3]) / 2, name: '' })
        } else {
            setPointLabel({ x: e.target.attrs.x, y: e.target.attrs.y, name: e.target.attrs.name })
        }

        if (e.target.attrs.fill === 'blue' && selectedShapes.length < 2) setLabelVisibility(true)
    }

    //DECREASES POINT SIZE AND REMOVES LABEL WITH NAME ON CLICK OFF
    const unpopShapes = () => {
        document.body.style.cursor = 'default'
        setPointClickState(false)
        setLineState(0)
        if (!context.mappingStatus) {
            for (let i = 0; i < layerRef.current.children.length; i++) {
                if (layerRef.current.children[i].getClassName() === 'Circle') {
                    layerRef.current.children[i].scaleX(1)
                    layerRef.current.children[i].scaleY(1)
                }
            }
        }

        context.actions.setSelector(false)
        setLabelVisibility(false)
    }

    //MODAL DISAPPEARING HANDLER
    const unpopModal = () => {
        unpopShapes()
        setPointName('')
        setSelectedRect({})
        setLinesInfo([])
        setIsNew(false)
        //shapeRef.current = {}
        if (JSON.stringify(preModalValues) !== JSON.stringify([deepClone(context.konvaPoints), deepClone(context.konvaEdges), deepClone(context.konvaAreas)])) {
            context.actions.setChanges([...context.changes, { old: preModalValues, new: [deepClone(context.konvaPoints), deepClone(context.konvaEdges), deepClone(context.konvaAreas)] }])
            context.actions.setUndone([])
        }

        document.getElementById('point-modal').classList.remove('is-active')
        document.getElementById('line-modal').classList.remove('is-active')
        document.getElementById('area-modal').classList.remove('is-active')
    }

    //PREVENTS REFRESH THROUGH PRESSING "ENTER" IN THE FORMS
    const preventRefresh = (e) => {
        //console.log(e.keyCode)
        if (e.keyCode === 13) {
            e.preventDefault()
            return false
        }
    }

    //SELECT BOX FUNCTIONS
    const handleMouseDown = (e) => {
        const stage = stageRef.current;
        const layer = layerRef.current;
        const pos = stage.getRelativePointerPosition(layer)

        if (e.target.getClassName() !== 'Rect') unpopShapes() //unpopShapes was preventing areas from being transformed as selector disappeared with Select tool

        if (e.evt.button === 2 || e.evt.touches?.length === 2) {
            setDraggable(true)
            stage.startDrag()
            document.body.style.cursor = 'grabbing'
        } else {
            setDraggable(false)
            stage.draggable(false)
            if (e.target.getClassName() !== 'Circle' && e.target.getClassName() !== 'Rect' && e.target.getClassName() !== 'Arrow') {
                selecting.current = true
                setSelectionBox({ visible: true, x1: pos.x, y1: pos.y, x2: pos.x, y2: pos.y, x: pos.x, y: pos.y, width: 0, height: 0 })
            }
        }
    }

    const handleMouseMove = (e) => {
        if (!selecting.current) return
        else {
            const stage = stageRef.current;
            const layer = layerRef.current;
            const pos = stage.getRelativePointerPosition(layer)

            setSelectionBox((prev) => {
                const x1 = prev.x1;
                const y1 = prev.y1;
                const x2 = pos.x;
                const y2 = pos.y;

                return {
                    visible: true,
                    x1,
                    y1,
                    x2,
                    y2,
                    x: Math.min(x1, x2),
                    y: Math.min(y1, y2),
                    width: Math.abs(x2 - x1),
                    height: Math.abs(y2 - y1),
                };
            })
        }
    }

    const handleMouseUp = (e) => {
        const stage = stageRef.current

        if (selectionRectRef.current) {
            if (e.evt.button === 2) {
                setDraggable(false)
                stage.stopDrag()
                document.body.style.cursor = 'default'
            } else if (!isDragging) {
                selecting.current = false
                setSelectionBox((prev) => ({ ...prev, visible: false }))

                const layer = layerRef.current
                if (!stage || !layer) return

                const box = selectionRectRef.current.getClientRect()

                const circles = layer.getChildren().filter((node) => node.getClassName() === 'Circle' && Konva.Util.haveIntersection(box, node.getClientRect()))

                circles.forEach((circle) => popShape({ target: circle }))

                console.log('SELECTED SHAPES: ', circles)
                setSelectedShapes(circles)
                trRef.current.nodes(circles)
                if (circles.length > 1) setLabelVisibility(false)
            }
        }
    }

    const handleContextMenu = (e) => {
        e.evt.preventDefault()
    }

    //RENDER
    return (
        <div>
            <div className='modal' id='point-modal'>
                <div className="modal-background" onClick={newCheck}></div>
                <div className='modal-card'>
                    <header className='modal-card-head'>
                        <p className='modal-card-title'>Point</p>
                        <button className="delete" aria-label="close" onClick={newCheck}></button>
                    </header>
                    <section className='modal-card-body' id='point-creator'>
                        <div className='controls'>
                            <div className='columns is-multiline is-align-items-center'>
                                <div className='column is-two-fifths is-flex is-align-items-center' style={{ padding: 0 }}>
                                    <label htmlFor='xPos' style={{ margin: 'auto', textAlign: 'left', width: '0.75rem' }}>x:</label>
                                    <input className='input' style={{ width: "10rem", marginRight: "0.5rem" }} type='text' id='xPos' value={menuPosX} onChange={manualCoords} />
                                    <label htmlFor='xPos' style={{ marginTop: 'auto', marginBottom: 'auto', marginRight: 'auto', textAlign: 'left', width: '0.75rem' }}>m</label>
                                </div>

                                <div className='column is-two-fifths is-flex is-align-items-center' style={{ padding: 0 }}>
                                    <label htmlFor='yPos' style={{ margin: 'auto', textAlign: 'left', width: '0.75rem' }}>y:</label>
                                    <input className='input' style={{ width: "10rem", marginRight: "0.5rem" }} type='text' id='yPos' value={menuPosY} onChange={manualCoords} />
                                    <label htmlFor='yPos' style={{ marginTop: 'auto', marginBottom: 'auto', marginRight: 'auto', textAlign: 'left', width: '0.75rem' }}>m</label>
                                </div>

                                <div className='column is-two-fifths is-flex is-align-items-center' style={{ justifyContent: 'center', fontSize: '0.8rem', padding: 0 }}>
                                    (max = {(context.mapDimensions.width * context.mapDimensions.resolution).toFixed(2)}m)
                                </div>

                                <div className='column is-two-fifths is-flex is-align-items-center' style={{ justifyContent: 'center', fontSize: '0.8rem', padding: 0 }}>
                                    (max = {(context.mapDimensions.height * context.mapDimensions.resolution).toFixed(2)}m)
                                </div>
                            </div>

                            <div style={{ color: 'darkblue' }}><input type='radio' name='pointType' id='nav' value='nav' checked={pointType[0]} onChange={pointProhibition} />&nbsp;Navigation</div>
                            <div style={{ color: 'darkred' }}><input type='radio' name='pointType' id='nogo' value='nogo' checked={pointType[1]} onChange={pointProhibition} />&nbsp;Prohibition</div>

                            {/*<div style={{ color: 'darkorange' }}><input type='radio' name='pointType' id='slow' value='slow' checked={pointType[2]} onChange={pointProhibition} />&nbsp;Slow Zone</div>*/}

                            <br />

                            <div className='control is-flex' style={{ width: '40%', display: 'none' }} id='pointName'>
                                <label style={{ marginTop: 'auto', marginBottom: 'auto', textAlign: 'left' }}>Name:&nbsp;</label>
                                <input className='input' placeholder="Type an ID" value={pointName} type='text' name='pointName' style={{ width: "10rem", marginRight: "0.5rem" }} onKeyDown={preventRefresh} onChange={nameSaver} autoFocus />
                            </div>
                        </div>
                    </section>
                    <footer className='modal-card-foot'>
                        <button className='button is-success' onClick={unpopModal} style={{ marginRight: '10px' }}>
                            <span className="icon is-small">
                                <FontAwesomeIcon icon={faSave} className="is-small" />
                            </span>
                            <span>
                                Save
                            </span>
                        </button>
                        {isNew &&
                            <button className='button' onClick={undoButton}>Cancel</button>
                        }
                        {!isNew &&
                            <button className='button is-danger' onClick={deletePoint} style={{ marginRight: '0.5rem' }}>Delete Point</button>
                        }
                    </footer>
                </div>
            </div>

            <div className='modal' id='area-modal'>
                <div className="modal-background" onClick={newCheck}></div>
                <div className='modal-card'>
                    <header className='modal-card-head'>
                        <p className='modal-card-title'>Area</p>
                        <button className="delete" aria-label="close" onClick={newCheck}></button>
                    </header>
                    <section className='modal-card-body' id='area-creator'>
                        <div className='controls'>
                            <div className='control is-flex' style={{ width: '60%', marginBottom: '1rem' }} id='areaVelocity'>
                                <label style={{ marginTop: 'auto', marginBottom: 'auto', textAlign: 'left' }}>Max. Velocity:&nbsp;</label>
                                <input className='input' style={{ width: "10rem", marginRight: "0.5rem" }} placeholder='0.0' min='0' step='0.1' type='number' id='maxV' onChange={velocityChange} />
                                <label style={{ marginTop: 'auto', marginBottom: 'auto', textAlign: 'left' }}>&nbsp;m/s</label>
                            </div>

                            <div className='control is-flex' style={{ width: '60%', marginBottom: '1rem' }} id='areaBeep'>
                                <div id='avoidance' style={{ marginTop: '10px' }}>Beep:&nbsp;<input type='checkbox' id='beep' onChange={onChangeBeep}></input></div>
                            </div>

                            <div className='control is-flex' style={{ width: '40%', marginTop: '1.9rem' }} id='areaName'>
                                <label style={{ marginTop: 'auto', marginBottom: 'auto', textAlign: 'left' }}>Name:&nbsp;</label>
                                <input className='input' placeholder="Type an ID" value={selectedRect.name} type='text' name='areaName' style={{ width: "10rem", marginRight: "0.5rem" }} onKeyDown={preventRefresh} onChange={areaNameSaver} autoFocus />
                            </div>
                        </div>
                    </section>
                    <footer className='modal-card-foot'>
                        <button className='button is-success' onClick={unpopModal} style={{ marginRight: '10px' }}>
                            <span className="icon is-small">
                                <FontAwesomeIcon icon={faSave} className="is-small" />
                            </span>
                            <span>
                                Save
                            </span>
                        </button>
                        {isNew &&
                            <button className='button' onClick={undoButton}>Cancel</button>
                        }
                        {!isNew &&
                            <button className='button is-danger' onClick={deleteArea} style={{ marginRight: '0.5rem' }}>Delete Area</button>
                        }
                    </footer>
                </div>
            </div>

            <div className='modal' id='line-modal'>
                <div className='modal-background' onClick={unpopModal}></div>
                <div className='modal-card'>
                    <header className='modal-card-head'>
                        <p className='modal-card-title'>Edge</p>
                        <button className='delete' aria-label='close' onClick={unpopModal}></button>
                    </header>
                    <form className='modal-card-body' id='line-editor'>
                        {shapeRef.current &&
                            <div>{shapeRef.current.attrs?.name?.toString()}</div>
                        }
                        <div style={{ marginTop: '10px' }}>2-way&nbsp;<input type='radio' name='direction' id='bothways' value='two' checked={lineType[0]} onChange={lineUpdate} /></div>
                        <div>P1 to P2&nbsp;<input type='radio' name='direction' id='wayone' value='str' checked={lineType[1]} onChange={lineUpdate} /></div>
                        <div>P2 to P1&nbsp;<input type='radio' name='direction' id='waytwo' value='inv' checked={lineType[2]} onChange={lineUpdate} /></div>
                        <div id='avoidance' style={{ marginTop: '10px' }}>Obstacle avoidance:&nbsp;<input type='checkbox' id='objAv' onChange={onChangeAvoid}></input></div>
                    </form>
                    <footer className='modal-card-foot'>
                        <button className='button is-success' onClick={unpopModal} style={{ marginRight: '10px' }}>
                            <span className="icon is-small">
                                <FontAwesomeIcon icon={faSave} className="is-small" />
                            </span>
                            <span>
                                Save
                            </span>
                        </button>
                        <button className='button is-danger' onClick={deleteLine} style={{ marginRight: '0.5rem' }}>Delete</button>
                        <button className='button' onClick={unpopModal}>Cancel</button>
                    </footer>
                </div>
            </div>

            {status === 'loaded' &&
                <Stage
                    id='stage'
                    ref={stageRef}
                    visible={stageVisibility}
                    width={document.getElementById('canvas-id')?.offsetWidth - 6}
                    height={document.getElementById('canvas-id')?.offsetHeight - 6}
                    draggable={context.selected.tool?._id === 'select' && !context.mappingStatus ? draggable : true}
                    onWheel={scrollZoom}
                    onTouchMove={!context.mappingStatus && context.selected.tool?._id === 'select' ? handleMouseMove : pinchZoom}
                    //onTouchEnd={pinchReset}
                    onTouchEnd={(e) => {
                        if (!context.mappingStatus) {
                            switch (context.selected.tool?._id) {
                                case 'areas':
                                    createArea(e)
                                    pinchReset(e)
                                    break

                                case 'points':
                                    createPoint(e)
                                    pinchReset(e)
                                    break

                                case 'select':
                                    handleMouseUp(e)
                                    if (pointClickState) unpopShapes()
                                    pinchReset(e)
                                    break

                                default:
                                    break
                            }
                        }
                    }}
                    onMouseUp={(e) => {
                        if (!context.mappingStatus) {
                            switch (context.selected.tool?._id) {
                                case 'areas':
                                    createArea(e)
                                    break

                                case 'points':
                                    createPoint(e)
                                    break

                                case 'select':
                                    handleMouseUp(e)
                                    if (pointClickState) unpopShapes()
                                    break

                                default:
                                    break
                            }
                        }
                    }
                    }
                    onDragStart={!context.mappingStatus && handleOnDragStart}
                    onDragEnd={!context.mappingStatus && handleOnDragEnd}
                    style={{ borderStyle: 'solid' }}
                    //onTouchStart={shapeSelector}

                    onContextMenu={handleContextMenu}
                    onMouseDown={!context.mappingStatus && (context.selected.tool?._id === 'select' && handleMouseDown)}
                    onTouchStart={!context.mappingStatus && (context.selected.tool?._id === 'select' && handleMouseDown)}
                    onMouseMove={!context.mappingStatus && (context.selected.tool?._id === 'select' && handleMouseMove)}
                >
                    {!context.mappingStatus &&
                        <Layer ref={layerRef}>
                            <Image
                                image={image}
                                onClick={mapDetection}
                                onTouchEnd={mapDetection}
                                ref={imageRef}
                            />

                            <Rect
                                ref={selectionRectRef}
                                draggable={true}
                                fill="rgba(0,0,255,0.5)"
                                visible={selectionBox.visible}
                                x={selectionBox.x}
                                y={selectionBox.y}
                                width={selectionBox.width}
                                height={selectionBox.height}
                                listening={false}
                            />

                            <Transformer
                                ref={(node) => {
                                    if (node) {
                                        if (context.selector) {
                                            const stage = node.getStage()
                                            //console.log(selectedRect)
                                            const rectangle = stage.findOne('.' + selectedRect.name)
                                            //console.log(rectangle)
                                            node.nodes([rectangle])
                                            node.getLayer().batchDraw()
                                        } else {
                                            node.nodes([])
                                            node.getLayer().batchDraw()
                                        }
                                    }
                                }}
                                keepRatio={false}
                                flipEnabled={false}
                                rotateEnabled={true}
                                onTransformEnd={updateAreas}
                                onMouseDown={() => console.log('transformer')}
                            //onClick={areaClick}
                            //onTouchEnd={areaClick}
                            />

                            <Text
                                visible={labelVisibility}
                                x={pointLabel.x - 15}
                                y={pointLabel.y - 18}
                                fontFamily="NeoTechAlt"
                                fontSize={10}
                                fill='black'
                                text={pointLabel.name}
                            />

                            {context.konvaAreas.map((floor) => (
                                <Rect
                                    {...floor}
                                    onClick={areaClick}
                                    onTouchEnd={areaClick}
                                    onDragStart={handleOnDragStart}
                                    onDragEnd={handleOnDragEnd}
                                />
                            ))}

                            {context.konvaEdges.map((cons) => (
                                <Arrow
                                    {...cons}
                                    //onMouseOver={popShape}
                                    //onMouseOut={unpopShapes}
                                    onMouseUp={context.selected.tool?._id !== 'points' ? lineMenu : createPoint}
                                    onTouchEnd={context.selected.tool?._id !== 'points' ? lineMenu : createPoint}
                                />
                            ))}

                            {context.konvaPoints.map((sky) => (
                                <Circle
                                    {...sky}
                                    onMouseUp={pointClick}
                                    //onMouseOut={unpopShape}
                                    //onClick={(e) => { editPoint(e); lineHandler(e) }}
                                    //onTouchEnd={(e) => { editPoint(e); lineHandler(e) }}
                                    //onClick={editPoint}
                                    onTouchEnd={pointClick}
                                    onTransformStart={handleOnDragStart}
                                    onTransformEnd={handleOnDragEnd}
                                />
                            ))}

                            <Transformer ref={trRef} resizeEnabled={false} />
                        </Layer>
                    }

                    {context.mappingStatus &&
                        <Layer ref={layerRef}>
                            <Image
                                image={image}
                                ref={imageRef}
                            />
                        </Layer>
                    }
                </Stage>
            }

            {context.lastMission === 'select-map' && !context.endOfMission &&
                <div id='loading' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh', textAlign: 'center', fontSize: 30 }}>Loading map...</div>
            }
        </div>
    );
};